import React from 'react';
import { Typography } from '@mui/material';
import { Box } from '@mui/material';
import { AccessTime as PendingIcon } from '@mui/icons-material';
import Stack from '@mui/material/Stack';

const formatDuration = (duration) => {
  if (!duration && duration !== 0) {
    return null;
  }

  const totalSeconds = Math.max(0, Math.round(duration));
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;

  return `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
};

const MessageMeta = ({ message }) => {
  // if (message.pending) {
  //   return (
  //     <Stack direction="row" spacing={2}>
  //       <PendingIcon sx={{ fontSize: '0.75rem', opacity: 0.6 }} />
  //     </Stack>
  //   );
  // }

  const hasDuration = Boolean(message.hasMedia && message.hasAudio && message.media?.duration);


  const durationLabel = formatDuration(message.media?.duration);

  return (
    <Box>
      <Stack
        direction="row"
        spacing={2}
        sx={{
          justifyContent: "flex-start",
          alignItems: "center",
        }}
      >

        {hasDuration && (
          <Typography
            variant="caption"
            pl={6}
            sx={{
              opacity: 0.8,
            }}
          >
            {durationLabel}
          </Typography>
        )}

        <Box sx={{ flexGrow: 1 }} />

        {message.pending ? (
          <PendingIcon fontSize="inherit" sx={{ opacity: 0.6 }} />
        ) : (
          <Typography
            variant="caption"
            sx={{
              opacity: 0.8,
            }}
          >
            {message.timestamp}
          </Typography>
        )}
      </Stack>
    </Box>
  );
};

export default MessageMeta;
